import { Box, Grid, makeStyles } from "@material-ui/core";
import { Description } from "@material-ui/icons";
import axios from "axios";
import { useEffect, useState } from "react";
import { hardBaseUrl } from "../../../services/urlConstant";
import {
  AutoCompleteWithSearch,
  CustomTable,
  ModalError,
  ModalSuccess,
  PrimaryButton,
  SearchTextInput,
  SelectInput,
  SkeletonComponent,
  TextInput,
} from "components";
import moment from "moment";
import { getErrors, removeDuplicates } from "utils";
import { getTotalPage } from "lib";
import {
  getListDSP,
  getListPeriodDSRF,
  getListFilesDSRF,
  processDSRF,
  processDSRFAppleMusic,
} from "utils/DSRFService";

const getAuthHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const useStyles = makeStyles(() => ({
  checkbox: {
    color: "black",
  },
  grid: {
    display: "flex",
    flexDirection: "row",
    alignItems: "end",
  },
  inputFields: {
    "& .MuiOutlinedInput-input": {
      padding: "0px",
      height: "44px",
      width: "268px",
    },
  },
}));

const ComponentReportProcess = () => {
  const classes = useStyles();
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const [selectedFile, setSelectedFile] = useState([]);
  const [optionPublisher, setOptionPublisher] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    size: 10,
    search: "",
  });
  const [periodQueryParams, setPeriodQueryParams] = useState({
    page: 1,
    size: 50,
  });
  const [hasMorePeriod, setHasMorePeriod] = useState(true);
  const [loadingPeriod, setLoadingPeriod] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [stateReportProcess, setStateReportProcess] = useState({
    listDSP: [],
    listPeriod: [],
    filter: {
      dsp: "",
      period: "",
      search: "",
    },
    publisher_ids: [],
    loading: false,
    reportProcess: [],
    exchange_rate: 0,
  });
  const {
    filter,
    listDSP,
    listPeriod,
    loading,
    reportProcess,
    publisher_ids,
    exchange_rate,
  } = stateReportProcess;
  const { dsp, period } = filter;
  const setValue = (key, value) =>
    setStateReportProcess(state => ({
      ...state,
      [key]: value,
    }));

  const setFilter = (key, value) =>
    setStateReportProcess(state => ({
      ...state,
      filter: {
        ...state.filter,
        [key]: value,
      },
    }));

  const getDsps = async () => {
    setValue("loading", true);
    try {
      const res = await getListDSP();
      setValue("listDSP", res?.data?.data || []);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setValue("loading", false);
    }
  };
  const getListPeriod = async () => {
    if (dsp) {
      setLoadingPeriod(true);
      try {
        const res = await getListPeriodDSRF({
          dsp_folder_name: dsp.toLowerCase(),
          page: periodQueryParams.page,
          size: periodQueryParams.size,
        });
        const rawData = res?.data?.data || [];
        const meta = res?.data?.meta;
        const newOptions = rawData.map(item => ({
          label:
            item?.period ||
            item?.period_name ||
            (item?.start_date
              ? moment(item.start_date).locale("id").format("MMMM YYYY")
              : item?.folder_name || ""),
          id:
            item?.folder_name ||
            (item?.start_date ? moment(item.start_date).format("YYYYMM") : ""),
          folder_name: item?.folder_name,
          ...item,
        }));
        setStateReportProcess(state => {
          const updatedList =
            periodQueryParams.page === 1
              ? newOptions
              : removeDuplicates([...state.listPeriod, ...newOptions], "id");
          if (meta?.total !== undefined) {
            setHasMorePeriod(updatedList.length < meta.total);
          } else {
            setHasMorePeriod(newOptions.length >= periodQueryParams.size);
          }
          return {
            ...state,
            listPeriod: updatedList,
          };
        });
      } catch (error) {
        ModalError(getErrors(error?.response));
      } finally {
        setLoadingPeriod(false);
      }
    }
  };

  const getOptionPublisher = async () => {
    try {
      setValue("loading", true);
      const params = {
        search: filter.search,
        is_active_flag: true,
      };
      const res = await axios.get(`${hardBaseUrl}/publisher`, {
        headers: getAuthHeaders(),
        params: Object.fromEntries(
          Object.entries(params).filter(([, value]) => value)
        ),
      });
      const { data, meta } = res?.data;
      const newOptions = (data || [])?.map(item => ({
        ...item,
        id: item?.publisher_id,
      }));
      setOptionPublisher(prev =>
        filter.page === 1 ? newOptions : [...prev, ...newOptions]
      );
      setHasMore(meta?.total > newOptions.length);
    } catch (error) {
      new Error(error);
      ModalError(getErrors(error?.response));
    } finally {
      setValue("loading", false);
    }
  };

  const getListReportDSP = async () => {
    if (period) {
      console.log({ period });
      setValue("loading", true);
      try {
        const response = await getListFilesDSRF({
          dsp_folder_name: dsp.toLowerCase(),
          period_folder_name: period,
          search: queryParams.search,
          is_reprocess: false,
          page: queryParams.page,
          size: queryParams.size,
        });
        setStateReportProcess(state => ({
          ...state,
          reportProcess: response?.data?.data || [],
        }));
        const pageCount = getTotalPage(
          response?.data?.meta?.total,
          queryParams?.size || 1
        );
        setTableTotalPage(pageCount);
      } catch (error) {
        ModalError("Data yang anda cari tidak ditemukan.");
      } finally {
        setValue("loading", false);
      }
    }
  };
  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const allSelected =
    reportProcess?.length > 0 &&
    reportProcess.every(item =>
      selectedFile?.some(selected => selected?.file_name === item?.file_name)
    );

  const handleSelectAllFile = event => {
    const { checked } = event?.target || false;
    if (checked) {
      setSelectedFile(prev => {
        const newItems = reportProcess.filter(
          item => !prev.some(sel => sel?.file_name === item?.file_name)
        );
        return [...prev, ...newItems];
      });
    } else {
      setSelectedFile(prev =>
        prev.filter(
          sel => !reportProcess.some(item => item?.file_name === sel?.file_name)
        )
      );
    }
  };

  const handleSelectFile = (event, option) => {
    const { checked } = event?.target || false;
    setSelectedFile(prev =>
      checked
        ? [...prev, option]
        : prev.filter(item => item?.file_name !== option?.file_name)
    );
  };

  const handleProcess = async () => {
    try {
      setValue("loading", true);
      const files = [];
      selectedFile.map(item => files.push(item.file_name));
      const publishers = [];
      publisher_ids.map(item => publishers.push(item.publisher_id));
      const payload = {
        dsp_folder_name: dsp.toLowerCase(),
        period_folder_name: period,
        dsrf_file_names: files,
        exchange_rate: Number(exchange_rate),
        publisher_ids: publishers,
      };

      const isAppleMusic =
        dsp?.toLowerCase()?.includes("apple") ||
        dsp?.toLowerCase()?.includes("itunes");

      const res = isAppleMusic
        ? await processDSRFAppleMusic(payload)
        : await processDSRF(payload);

      ModalSuccess(res?.data?.message || "Process initiated").then(() => {
        window.location.reload();
      });
    } catch (error) {
      ModalError(getErrors(error));
    } finally {
      setValue("loading", false);
    }
  };

  const tableColumn = [
    {
      name: "file_name",
      title: "File Name",
      renderText: item => {
        return (
          <Grid className={classes.grid} direction="column" container>
            <Description />
            {item || "-"}
          </Grid>
        );
      },
    },
  ];

  useEffect(() => {
    getDsps();
    getOptionPublisher();
  }, []);

  useEffect(() => {
    if (dsp) {
      getListPeriod();
    }
  }, [dsp, periodQueryParams]);

  useEffect(() => {
    getListReportDSP();
  }, [dsp, period, queryParams]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item>
            <SelectInput
              label="DSP"
              value={dsp}
              onChange={({ target }) => {
                const selectedDsp = target.value || "";
                setSelectedFile([]);
                setPeriodQueryParams({ page: 1, size: 50 });
                setHasMorePeriod(true);
                setStateReportProcess(state => ({
                  ...state,
                  filter: {
                    ...state.filter,
                    dsp: selectedDsp,
                    period: "",
                  },
                  listPeriod: [],
                  reportProcess: [],
                }));
              }}
              options={listDSP}
              optionKey="folder_name"
              optionLabel="dsp_name"
              placeholder="None"
              width={250}
            />
          </Grid>
          <Grid item>
            <AutoCompleteWithSearch
              key={dsp || "empty"}
              disabled={!dsp}
              options={listPeriod}
              label="Period"
              placeholder={dsp ? "Select Period" : "Select DSP first"}
              uniqueKey="id"
              value={
                listPeriod.find(
                  option => String(option.id) === String(period)
                ) || null
              }
              onChange={item => {
                setSelectedFile([]);
                setFilter("period", item?.id || "");
              }}
              optionLabel="label"
              onInputChange={() => {}}
              filterOptions={(options, state) => {
                if (!state.inputValue) return options;
                const selectedOption = options.find(
                  opt => String(opt.id) === String(period)
                );
                if (
                  selectedOption &&
                  state.inputValue === selectedOption.label
                ) {
                  return options;
                }
                const search = state.inputValue.toLowerCase();
                return options.filter(opt => {
                  const labelMatch = (opt?.label || "")
                    .toLowerCase()
                    .includes(search);
                  const folderMatch = (opt?.folder_name || "")
                    .toLowerCase()
                    .includes(search);
                  const idMatch = String(opt?.id || "")
                    .toLowerCase()
                    .includes(search);
                  return labelMatch || folderMatch || idMatch;
                });
              }}
              isOptionEqualToValue={(option, value) =>
                String(option?.id) === String(value?.id)
              }
              setQueryParams={setPeriodQueryParams}
              hasMore={hasMorePeriod}
              loading={loadingPeriod}
              width={250}
            />
          </Grid>
          {period && (
            <>
              <Grid item>
                <AutoCompleteWithSearch
                  multiple
                  disableCloseOnSelect
                  value={publisher_ids}
                  options={removeDuplicates(optionPublisher, "publisher_id")}
                  onChange={item =>
                    setStateReportProcess({
                      ...stateReportProcess,
                      publisher_ids: item,
                    })
                  }
                  isOptionEqualToValue={(option, value) =>
                    option?.publisher_id === value?.publisher_id
                  }
                  inputValue={filter?.search}
                  uniqueKey="publisher_id"
                  onInputChange={value => setFilter("search", value || "")}
                  optionLabel="name"
                  placeholder="Publisher Name"
                  setQueryParams={setQueryParams}
                  hasMore={hasMore}
                  width={250}
                />
              </Grid>
              <Grid item>
                <TextInput
                  label={"Exchange Rate"}
                  placeholder={"Exchange Rate"}
                  value={exchange_rate}
                  onChange={e =>
                    setStateReportProcess({
                      ...stateReportProcess,
                      exchange_rate: e.target.value,
                    })
                  }
                  startAdornment={"Rp"}
                  width={200 || "auto"}
                />
              </Grid>
              <Grid item>
                <SearchTextInput
                  placeholder="Search"
                  value={queryParams?.search}
                  onChange={event =>
                    handleChangeQueryParams(event.target.value, "search")
                  }
                />
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
      <Grid item xs={12}>
        {loading ? (
          <SkeletonComponent variant="wave" />
        ) : (
          <CustomTable
            columnTable={tableColumn}
            isLoading={loading}
            data={reportProcess}
            page={queryParams?.page}
            pageSize={queryParams?.size}
            pageCount={tableTotalPage}
            handleChangePage={(_, page) =>
              handleChangeQueryParams(page, "page")
            }
            handleChangePageSize={e =>
              handleChangeQueryParams(e?.target?.value, "size")
            }
            isHaveCheckbox={reportProcess?.length > 0}
            checkboxHeaderChecked={allSelected}
            handleCheckboxHeader={handleSelectAllFile}
            checked={item =>
              selectedFile?.some(
                selected => selected?.file_name === item?.file_name
              )
            }
            handleCheckbox={handleSelectFile}
          />
        )}
      </Grid>
      <Grid item xs={12}>
        <Box display="flex" justifyContent="flex-end">
          {selectedFile?.length > 0 && (
            <PrimaryButton label="Start" onClick={handleProcess} />
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default ComponentReportProcess;
